import FinancingApp from 'apps/Financing'
import axios from 'axios'
import get from 'lodash/get'
import { financingFaqsSection, socialMediaSeoTagsFinancing, jsonLDFinancing } from 'vars'
import { safePromise } from 'utils/universal/safePromise'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'
import financingMessages from 'lang/es/financing'
import { internalSectionMapper, timelineAndVideoMapper } from 'mappers/commonMapper'

export default FinancingApp

export const getStaticProps = async () => {
  const commonStaticProps = await getCommonStaticProps()
  const messages = {
    ...commonMessages,
    ...financingMessages,
  }
  const url = `${process.env.NEXT_PUBLIC_API_WORDPRESS}/acf/v3/options/financing`
  const { result } = await safePromise(axios(url))
  const internalSections = get(result, 'data.acf.internal_sections', [])
  const mainBanner = {
    title: get(result, 'data.acf.title', ''),
    subtitle: get(result, 'data.acf.subtitle', ''),
    mainImage: get(result, 'data.acf.main_image', {}),
    video_url: get(result, 'data.acf.video_url', ''),
    buttons: get(result, 'data.acf.buttons', ''),
    disclaimer: get(result, 'data.acf.disclaimer', ''),
  }
  const timeline = get(result, 'data.acf.timeline_and_video', {})

  return {
    props: {
      titleMeta: 'FINANCING_TITLE',
      descriptionMeta: 'FINANCING_DESCRIPTION',
      headerProps: {
        activeIndex: 2,
        showBackButton: false,
        whatsappMessage: {
          id: 'FINANCING_WHATSAPP_MESSAGE',
        },
      },
      mainBanner,
      internalSections: internalSectionMapper(internalSections),
      timeline: timelineAndVideoMapper(timeline),
      financingFaqsSection,
      messages,
      socialMediaTags: socialMediaSeoTagsFinancing,
      jsonLDData: jsonLDFinancing,
      ...commonStaticProps,
    },
  }
}
